import { render, staticRenderFns } from "./doctor.vue?vue&type=template&id=58f5e5b0"
import script from "./doctor.vue?vue&type=script&lang=js"
export * from "./doctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58f5e5b0')) {
      api.createRecord('58f5e5b0', component.options)
    } else {
      api.reload('58f5e5b0', component.options)
    }
    module.hot.accept("./doctor.vue?vue&type=template&id=58f5e5b0", function () {
      api.rerender('58f5e5b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/doctor.vue"
export default component.exports